/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 150,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    value8: "",
    value9: "",
    value10: "",
    value11: "",
  },
];

export default function CorporateIncomeTaxTable20A({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
    };

    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex">
        <Typography variant="h5">
          MỤC I. TỔNG QUAN VỀ HOẠT ĐỘNG PHÂN BỐ THU NHẬP, THUẾ VÀ HOẠT ĐỘNG KINH DOANH THEO QUỐC GIA
          CƯ TRÚ
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Quốc gia
              </Td>
              <Td rowSpan={1} colSpan={3} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Doanh thu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Lợi nhuận trước thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tổng số thuế thu nhập doanh nghiệp phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Thuế thu nhập đã nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Vốn đăng ký
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Lợi nhuận lũy kế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Số lượng nhân viên
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tài sản hữu hình ngoại trừ tiền và các khoản tương đương tiền
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Bên độc lập
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Bên liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tổng
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                  className="toggle-button"
                >
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value1", value: e.target.value })
                    }
                  >
                    <option value="value1">Việt Nam</option>
                    <option value="value2">Mỹ</option>
                  </select>
                  <div className="button-action delete" style={{ left: "-45px" }}>
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value2}
                    name="value2"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value3}
                    name="value3"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value4}
                    name="value4"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value5}
                    name="value5"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value6}
                    name="value6"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value7}
                    name="value7"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value8}
                    name="value8"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value9}
                    name="value9"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value10}
                    name="value10"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <InputTable
                    id={item.id}
                    value={item.value11}
                    name="value11"
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <SoftButton sx={{ mt: 1 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
